/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Tier_Free_Shipping_LabelInputs */

const vi_shop_tier_free_shipping_label = /** @type {(inputs: Shop_Tier_Free_Shipping_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miễn ship`)
};

/**

* @param {Shop_Tier_Free_Shipping_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_free_shipping_label = /** @type {((inputs?: Shop_Tier_Free_Shipping_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Free_Shipping_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_free_shipping_label(inputs)
});